import axios from 'axios';

let juniorApi = axios.create({
    baseURL: appConfig.juniorBaseApiUrl,
    timeout: 1000,
    headers: {
        'X-Custom-Header': 'foobar'
    }
});

export default juniorApi;
